import React from 'react'
import Spacer from './spacer'
import robotdesign from '../images/robotdesign.png';
import robocon1 from '../images/robocon1.jpg';
import robocon2 from '../images/robocon2.jpg';
import newslet from '../images/newslet.png';
import cfg from '../images/cfg.jpeg';

const images = [
    {
        "src":robocon1,
        "desc":"lmmao"
    },
    {
        "src":robocon2,
        "desc":"lmmao2"
    }
]
export default function Activities(){
    return <div>
        <h3>Activities and Compeititons</h3>
        <div style={{textAlign:"justify"}}>
            As a tech enthusiast, an avid problem-solver and a competitive person, I always seeked opportunities for me to learn from others 
            and joined activities and competitions to put my ability to test while coming up with solutions to solve problems. 
            The following is a brief summary of the acitivies and competitions I have been part of.

        </div>
        <Spacer size={15}/>
        <div>
            <ul>
                <li>
                    <h5>HKUST Robot Design Contest 2018 - 1st Runner Up</h5>
                    <p style={{textAlign:"justify"}}>
                        HKUST Robot Design Contest is a yearly competition organised by the <strong><a href="https://robotics.ust.hk/" target="_blank">HKUST Robotics Team</a></strong> every November and is the final round of the rigorous selection process to join the team.
                        After passing through two rounds of training, workshop and selection process, I joined an inter-disciplinary team, considering software, hardware and mechanical mentees, to prepare for the final competition.
                        As a software mentee, I was in-charge of coming up with a method to write an <i>auto-pathing algorithm for the thrower robot, selecting the necessary sensors to implement the algorithm and implementing a manual control mode for the thrower robot. </i>
                         Our team was named <strong>LG1</strong>, signifiying our group number 1, and we were able to attain the <strong>first runner-up</strong> in this competition.
                    </p>
                    <Spacer size={5}/>
                    <ul>
                        <li><a href="https://www.youtube.com/watch?v=aryFjliFHjQ" target="_blank">Link to the game challenge video</a></li>
                        <li><a href="https://www.youtube.com/watch?v=IMOQItFXDcU" target="_blank">Link to the competition video</a></li>
                    </ul>
                    <Spacer size={5}/>
                    <figure>
                        <img src={robotdesign} width="500"/>
                        <figcaption><b>A smile of victory for team LG1 with the mentors and our robots.</b>
                        </figcaption>
                    </figure>
                </li>
                <li>
                    <h5>Hong Kong Robocon 2019 - 2nd Runner Up</h5>
                    <p style={{textAlign:"justify"}}>
                        Hong Kong Robocon Contest is a yearly competition organised by the HKSTP to select the representatitve team for Hong Kong for the international Robocon Contest.
                        As a member of the HKUST Robocon team, I worked with a team of 30 people from software,hardware and mechanical discpline for <strong>7 months (December to June)</strong> to prepare for this competition.
                        As a junior software member, I was in charge of MR1 of the sub-team War Dragon where I contributed to the auto-pathing algorithms, robot localization, sensor fusion and a semi-manual control integration of the robot.
                        On the side, I also conducted a <strong>research and development project on Light Detection and Ranging (LiDAR sensor)</strong> for robot localization for future use for the HKUST robocon team.
                    </p>
                    <Spacer size={5}/>
                    <div>
                        <ul>
                            <li><a href="https://www.youtube.com/watch?v=u6gRn_0Jz0c" target="_blank">Link to the game challenge video</a></li>
                        </ul>
                    </div>
                    <Spacer size={5}/>
                    <figure>
                        <img src={robocon1} width="500"/>
                        <figcaption>HKUST Robocon, WarDragon, before the official competition.
                        </figcaption>
                    </figure>
                    <Spacer size={5}/>
                    <figure>
                        <img src={robocon2} width="500"/>
                        <figcaption>A beautiful snapshot of our MR2, the highlight of this competition.
                        </figcaption>
                    </figure>
                </li>
                <li>
                    <h5>Hong Kong Techathon 2020 - Champion in Big Data and Fintech</h5>
                    <p style={{textAlign:"justify"}}>
                        Hong Kong Techathon 2020 was a 42-hour challenge for a team of programmers, designers, marketers and entreprenuers to come up with ideas, prototypes and pitch for seed fund and incubation support.
                        As a team of 5, my friends and I joined this competition in the category of <strong>Big Data and Fintech</strong>. <br/><br/>

                        <strong>Our Pitch</strong><br/>
                        In the current age, investment and trading in the stock market has become many people's side job for side income, however, not everyone has the knowledge or the skills to do it effectively to make a profit.
                        To let that average-Joe with no knowledge of the financial world or the skills to trade and invest in stocks, we came up with <strong><i>Newslet</i></strong>, a one stop shop that compiles financial news and analyse the news 
                        with the help of machine learning and natural language processing to give an indication on the possible trend of a particular financial instrument.
                        <Spacer size={5}/> 
                        <figure>
                            <img src={newslet} width="500"/>
                        </figure>
                    </p>
                </li>
                <li>
                    <h5>Code For Good by JP Morgan 2020 - Winner</h5>
                    <p style={{textAlign:"justify"}}>
                        Code for Good is a yearly event organised by JPMorgan Chase & Co. to bring in university students to their offices and brainstorm twenty-four hours on how nonprofits can solve a challenge they're facing.
                        Code for Good 2020 was a virtual Hackathon and I was part of an amazing winning team, team 27, that delivered our idea to digitise and optimise the operation of the nonprofit, <strong>Junior Achievement Hong Kong</strong> , through the usage of our solution.
                        As part of a 7 member team, I was one of the two main members who worked on the frontend in <strong>ReactJs</strong> to deliver a <strong>progressive web app (PWA)</strong> and delivered an end-to-end working prototype by the end of the 24 hours.
                        <Spacer size={8}/>
                        <ul>
                            <li><a href="https://www.linkedin.com/posts/binay-gurung_jpmorgan-codeforgood-activity-6721791548570378240-QK86" target="_blank">Link to the LinkedIn post</a></li>
                        </ul>
                        <Spacer size={5}/>
                        <figure>
                            <img src={cfg} width="500"/>
                        </figure>
                    </p>
                </li>
            </ul>
        </div>
    </div>
}